/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type PresetCreatePresetType = typeof PresetCreatePresetType[keyof typeof PresetCreatePresetType];


export const PresetCreatePresetType = {
  companies: 'companies',
  universities: 'universities',
  job_titles: 'job_titles',
  skills: 'skills',
  investors: 'investors',
  locations: 'locations',
  filters: 'filters',
  job_stages: 'job_stages',
} as const;
